<template>
  <div class="wrapper-full">
    <!-- <split-h class="split-h" :splitH="1"></split-h> -->
    <div
      :style="`${width}px;height:${height}px;margin:0 auto;overflow:hidden;position:relative;margin-left:5px`"
    >
      <video
        :id="videoId ? videoId : 'dryeyeVideo'"
        :src="src"
        :style="`background:black;width:${width}px;height:${height}px;position: absolute;top: 0;left: 10px;`"
        class="video"
        muted
        @timeupdate="timeupdate"
        @loadedmetadata="loadedmetadata"
        @canplay="canplay"
        @ended="ended"
        ref="video"
        @click="playPauseVideo"
      ></video>

      <canvas
        ref="pupilconeavideoRef"
        id="pupilconeavideo"
        :width="width"
        :height="height"
        :style="`position: absolute;top: 0;left: 10px;width:${width}px;height:${height}px`"
      ></canvas>

      <div
        class="speed-switch"
        :style="`${butVideo ? 'left:0' : 'right:0;left:unset'}`"
        v-if="isZHCN"
      >
        <span style="font-size: 20px; vertical-align: middle"
          >{{ $t("langcfg.txtDoubleSpeed") }}:</span
        >
        <el-radio-group v-model="playbackRate" @change="speedChange">
          <el-radio :label="0.5">0.5X</el-radio>
          <el-radio :label="1">1.0X</el-radio>
          <el-radio :label="2">2.0X</el-radio>
        </el-radio-group>
      </div>
      <div class="video-mask" v-if="isPaused && isMaskVisible" @click="playPauseVideo">
        <div :class="playIcon" style="font-size: 150px; color: rgba(255, 255, 255, 0.5)"></div>
      </div>
      <div v-if="butVideo" class="but-switch">
        <el-radio-group v-model="selectedVideo" @change="selectedVideoChange">
          <el-radio :label="0">{{ $t("langcfg.txtUserPlacidoLipidlayerRecoup") }}1</el-radio>
          <el-radio :label="1">{{ $t("langcfg.txtUserPlacidoLipidlayerRecoup") }}2</el-radio>
          <el-radio :label="2">{{ $t("langcfg.txtUserPlacidoLipidlayerRecoup") }}3</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- <split-h class="split-h" :splitH="10"></split-h> -->
    <div style="width: 100%; position: relative">
      <table style="width: 100%; padding-top: 16px" id="table">
        <tbody>
          <tr style="overflow: visible; position: relative">
            <td width="60" align="left" @click="playPauseVideo">
              <div :class="playIcon" style="font-size: 40px; margin-left: 10px"></div>
            </td>
            <td align="center">
              <!-- 左箭头startTime -->
              <!-- v-if="startTime>=0" -->
              <div ref="timeTool" v-if="false">
                <i class="tocenter" style="display: block">{{ startTime }}s</i>
                <i class="el-icon-caret-bottom" style="display: block"> </i>
              </div>
              <el-slider
                :step="step"
                v-model="sliderVal"
                @input="changCurrentTime"
                @change="change"
                @mousedown.native.stop="onMouseDown"
                :format-tooltip="tooltip"
                show-tooltip
                :marks="MK"
              ></el-slider>
              <!-- 右箭头usefulTime -->
              <!-- v-if="usefulTime" -->
              <div ref="endTool" v-if="false">
                <i class="tocenter" style="display: block">{{ usefulTime }}s</i>
                <i class="el-icon-caret-bottom" style="display: block"> </i>
              </div>
            </td>
            <td width="160" align="center" style="font-size: 20px" @click="playPauseVideo">
              {{ playTime }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import EVENTS from "../../bus";
import { Size } from "../../mixins";
import { isDefined } from "../../shared/utils";
import paper from "paper";
import NewGraphProc from "../../common/js/graphics_new";

function paperInit(canvasid, width, height) {
  for (let i in paper.projects) {
    if (paper.projects[i].view) {
      if (paper.projects[i].view.element.id === canvasid) {
        paper.projects[i].remove();
      }
    }
  }

  paper.setup(canvasid);

  let graph = new NewGraphProc(paper, window.magecoe["pupilcornea"]);
  return graph;
}
function formatSeconds(v) {
  let min = parseInt(v / 60.0)
    .toFixed(0)
    .padStart(2, 0);
  let sec = Math.ceil(v % 60)
    .toFixed(0)
    .padStart(2, 0);
  return `${min} : ${sec}`;
}
export default {
  name: "PupilCorneaVideo",
  data() {
    return {
      paper: null,
      currentTime: 0,
      sliderVal: 0,
      duration: 0,
      url: "static/test.mp4",
      step: 1,
      isPaused: false,
      scale: 1,
      isMouseDown: false,
      video: undefined,
      isContiAfterDragged: true,
      isCanplay: false,
      realTime: 0,
      videoE: "",
      marks: {},
      selectedVideo: 0,
      playbackRate: 1,
      speedOptions: [
        {
          value: 0.5,
          label: "0.5X"
        },
        {
          value: 1,
          label: "1.0X"
        },
        {
          value: 2,
          label: "2.0X"
        }
      ],
      isZHCN: true,
      ctx: null
    };
  },
  mixins: [Size],
  props: {
    record: {
      type: Object
    },
    currentEye: {
      type: String,
      default: "OS"
    },
    butVideo: {
      type: Boolean,
      default: false
    },
    BlinkVideo: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ""
    },
    width: Number,
    height: Number,
    realTotalTime: {
      type: Number
    },
    usefulTime: {
      type: Number
    },
    startTime: {
      type: Number
    },
    zoom: {
      type: Number,
      default: 1.5
    },
    isMaskVisible: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String,
      default: ""
    },
    pupilCenterX: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pupilCenterY: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ringCenterX: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ringCenterY: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pupilDiameterData: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  mounted() {
    document.addEventListener("mouseup", this.onmouseup);
    // this.$bus.$on('add-keydown', () => {
    //   document.addEventListener('keydown', this.onkeydown)
    // })
    // this.$bus.$on('remove-keydown', () => {
    //   document.removeEventListener('keydown', this.onkeydown)
    // })

    // this.$bus.$emit('add-keydown')

    this.isZHCN = window.settings.language === "zh_CN";

    // this.paper = paperInit("pupilconeavideo", this.width, this.height);

    this.ctx = this.$refs.pupilconeavideoRef.getContext("2d");
    this.drawPupilEdge({
      r: this.pupilDiameterData[0] / this.scaleVideo / 2,
      x: this.pupilCenterX[0] / this.scaleVideo,
      y: this.pupilCenterY[0] / this.scaleVideo,
      rx: this.ringCenterX[0] / this.scaleVideo,
      ry: this.ringCenterY[0] / this.scaleVideo
    });

    // ctx.strokeStyle = '#0f0';
    // ctx.lineWidth = 2;

    // for (let i = 1; i <= 3; i++) {
    //     ctx.beginPath();
    //     ctx.arc(200, 200, i * (400 / 3), 0, Math.PI * 2);
    //     ctx.stroke();
    // }
    this.$bus.$on("PUPILVIDEOCHANGE", () => {
      this.drawPupilEdge({
        r: this.pupilDiameterData[0] / this.scaleVideo / 2,
        x: this.pupilCenterX[0] / this.scaleVideo,
        y: this.pupilCenterY[0] / this.scaleVideo,
        rx: this.ringCenterX[0] / this.scaleVideo,
        ry: this.ringCenterY[0] / this.scaleVideo
      });
    });

    this.$bus.$on("CHANGEVIDEOSPEEDBTN", () => {
      this.isZHCN = window.settings.language === "zh_CN";
    });

    this.$bus.$on("PAUSEVIDEO", () => {
      this.video.pause();
      this.isPaused = true;
      this.isContiAfterDragged = true;
    });
  },
  beforeDestroy() {
    this.video.pause();
    this.video.removeAttribute("src");
    this.video.load();
    this.isPaused = true;
    this.isContiAfterDragged = true;
    this.$bus.$off("PUPILVIDEOCHANGE");
    this.$bus.$off("PAUSEVIDEO");
    this.$bus.$off("CHANGEVIDEOSPEEDBTN");

    document.removeEventListener("mouseup", this.onmouseup);
    document.removeEventListener("keydown", this.onkeydown);
  },
  methods: {
    drawPupilEdge(edge) {
      if (!edge || !edge.r || edge.r <= 0) return;
      const { x, y, r, rx, ry } = edge;
      const dashArrayCircle = [6, 3];
      const dashArrayLine = [6, 1];
      const dashArrayLine1 = [12, 5];

      // 清除之前的绘制
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);

      // 画瞳孔的圆形边缘
      this.ctx.beginPath();
      this.ctx.setLineDash(dashArrayCircle);
      this.ctx.arc(x, y, r, 0, 2 * Math.PI);
      this.ctx.strokeStyle = "#0f0";
      this.ctx.lineWidth = 2;
      this.ctx.stroke();
      this.ctx.setLineDash([]); // 重置为实线

      // 画瞳孔中心水平十字线
      this.ctx.beginPath();
      this.ctx.setLineDash(dashArrayLine);
      this.ctx.moveTo(x - 10, y);
      this.ctx.lineTo(x + 10, y);
      this.ctx.strokeStyle = "#0f0";
      this.ctx.lineWidth = 2;
      this.ctx.stroke();

      // 画瞳孔中心垂直十字线
      this.ctx.beginPath();
      this.ctx.moveTo(x, y - 10);
      this.ctx.lineTo(x, y + 10);
      this.ctx.strokeStyle = "#0f0";
      this.ctx.lineWidth = 2;
      this.ctx.stroke();

      // 画环中心水平十字线
      this.ctx.beginPath();
      this.ctx.setLineDash(dashArrayLine1);
      this.ctx.moveTo(rx - 40, ry);
      this.ctx.lineTo(rx + 40, ry);
      this.ctx.strokeStyle = "#fff";
      this.ctx.lineWidth = 2;
      this.ctx.stroke();

      // 画环中心垂直十字线
      this.ctx.beginPath();
      this.ctx.moveTo(rx, ry - 40);
      this.ctx.lineTo(rx, ry + 40);
      this.ctx.strokeStyle = "#fff";
      this.ctx.lineWidth = 2;
      this.ctx.stroke();
    },
    onmouseup() {
      this.isMouseDown = false;
      if (this.video && this.isCanplay && this.isContiAfterDragged && !this.isPaused) {
        this.video.play();
      }
    },
    onkeydown(e) {
      if (!isDefined(e)) return;
      // e.preventDefault()
      if (e.code === "Space") {
        this.playPauseVideo();
      }
    },
    playPauseVideo() {
      if (!this.video) return;
      if (this.isPaused) {
        this.video.play();
      } else {
        this.video.pause();
      }
      this.isPaused = !this.isPaused;
      this.isContiAfterDragged = !this.isPaused;
    },
    changCurrentTime(val) {
      if (this.isMouseDown && this.isCanplay) {
        this.video.currentTime = Math.round(((val / 100) * this.realTime) / this.scale);
        this.currentTime = (val / 100) * this.realTime;
      }
    },
    change(val) {
      if (!this.isMouseDown) {
        this.video.currentTime = Math.round(((val / 100) * this.realTime) / this.scale);
        this.currentTime = (val / 100) * this.realTime;
      }
    },
    canplay() {
      this.isCanplay = true;
    },
    loadedmetadata(e) {
      this.currentTime = this.startTime;
      this.video = this.$refs.video;
      if (!this.video) return;
      this.video.currentTime = this.startTime || 0;
      const { duration } = e.target;
      this.duration = duration;
      // console.log('视频video', this.video)
      // 如果有算法totalTime 就是算法时间，没有算法时间就是元视频时间
      if (this.realTotalTime === -1) {
        this.realTime = duration;
      } else {
        this.realTime = this.realTotalTime;
      }

      // if(this.realTime > 9.9 && this.realTime < 10) {
      //   this.realTime = 10
      // }
      this.realTime = Math.round(this.realTime);
      // if(this.realTime !== 10) {
      //   this.realTime = 10
      // }

      // this.realTime = this.realTotalTime === -1 ? duration : this.realTotalTime
      this.scale = (this.realTime * 1.0) / duration;
      // 步长
      this.step = 100 / this.realTime;
      // if (isDefined(this.startTime) && this.startTime >= 0) {
      //   this.currentTime = this.startTime * this.scale
      //   // 指针部分
      //   let sliderWidth = 1128
      //   let toFixedTime = Math.ceil(this.realTime)
      //   let scale = sliderWidth / toFixedTime
      //   let startPosition = scale * this.startTime + 50
      //   let endPosition = scale * this.usefulTime
      //   let timeToolLeft = `${startPosition}px`
      //   let endToolLeft = `${endPosition}px`
      //   const timeTool = this.$refs.timeTool
      //   const endTool = this.$refs.endTool
      //   timeTool.style.position = 'absolute'
      //   timeTool.style.left = timeToolLeft
      //   timeTool.style.bottom = '28px'

      //   endTool.style.position = 'absolute'
      //   endTool.style.left = endToolLeft
      //   endTool.style.bottom = '28px'
      // }
      this.isPaused = true;
      // this.video.play()
    },
    tooltip(val) {
      return formatSeconds(this.currentTime);
      // return val / 100
    },
    timeupdate(e) {
      if (e.target) {
        this.videoE = e;
        const { currentTime } = e.target;

        if (!this.isMouseDown) {
          if (currentTime * this.scale > 9.9) {
            this.currentTime = 10;
          } else {
            this.currentTime = Math.floor(currentTime * this.scale);
          }
          this.sliderVal = 100 * (this.currentTime / this.realTime);
        }

        if (currentTime) {
          let index = 0;
          if (currentTime <= 0.12) {
            index = 0;
          } else {
            index = Number(currentTime.toFixed(1)) * 10;
          }

          if (index === 100) {
            index = 99;
          }
          if (!this.pupilDiameterData[index]) {
            // 值为null的情况下清除绘制
            this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
          } else {
            this.drawPupilEdge({
              r: this.pupilDiameterData[index] / this.scaleVideo / 2,
              x: this.pupilCenterX[index] / this.scaleVideo,
              y: this.pupilCenterY[index] / this.scaleVideo,
              rx: this.ringCenterX[index] / this.scaleVideo,
              ry: this.ringCenterY[index] / this.scaleVideo
            });
          }
        }
      }
    },
    ended() {
      this.isPaused = true;
      // this.currentTime = this.realTime
      // this.isPaused = false
      // this.video.currentTime = this.startTime
      // this.video.play()
    },
    onMouseDown() {
      if (this.isCanplay) {
        this.video.pause();
        this.isMouseDown = true;
      }
    },
    selectedVideoChange(value) {
      this.$emit("if-OS", this.record, value);
      this.playbackRate = 1;
    },
    speedChange(speed) {
      let video = document.getElementById(`${this.videoId ? this.videoId : "dryeyeVideo"}`);
      video.playbackRate = speed;
    }
  },
  updated() {
    // 切换到脂质层时数据的手动更新操作
    if (this.realTotalTime === -1) {
      if (!isDefined(this.videoE.target)) return;
      // this.realTime = parseInt(this.$refs.video.duration)
      this.realTime = Math.round(this.realTime);
      // if(this.realTime !== 10) {
      //   this.realTime = 10
      // }
      this.scale = 1.0;
      const { currentTime } = this.videoE.target;

      if (!this.isMouseDown) {
        if (currentTime * this.scale > 9.9) {
          this.currentTime = 10;
        } else {
          this.currentTime = Math.floor(currentTime * this.scale);
        }
        this.sliderVal = 100 * (this.currentTime / this.realTime);
      }
    }
    this.isZHCN = window.settings.language === "zh_CN";
  },
  watch: {
    src(newVal) {
      this.src = newVal;
      this.isCanplay = false;
    }
  },
  computed: {
    scaleVideo() {
      return 1024 / this.width;
    },
    MK() {
      let marks = {};
      let endTime = (this.usefulTime + this.startTime).toFixed(2);
      // console.log("步长" ,this.step)
      marks[this.startTime * this.step] = {
        style: {
          color: "#1989FA"
        },
        label: this.$createElement("strong", this.startTime)
      };
      marks[endTime * this.step] = {
        style: {
          color: "#1989FA"
        },
        label: this.$createElement("strong", endTime)
      };
      return marks;
    },
    playTime() {
      let front = this.currentTime === -1 ? "--:-- " : formatSeconds(this.currentTime || 0); // 加上|| 防止加载时闪NAN
      // console.log(front)
      let back = !isDefined(this.realTime) ? "--:--" : formatSeconds(this.realTime || 0); // 加上|| 防止加载时闪NAN
      return `${front} / ${back}`;
    },
    playIcon() {
      return this.isPaused ? "el-icon-video-play" : "el-icon-video-pause";
    },
    vwidth() {
      return this.dispW - 500;
    },
    vheight() {
      if (this.BlinkVideo) {
        return this.dispH - 100 - 130 - 250;
      } else {
        return this.dispH - 100 - 130;
      }
    },
    dispwidth() {
      return this.zoom * (this.dispW - 500);
    },
    dispheight() {
      if (this.BlinkVideo) {
        return this.vheight;
      } else {
        return this.zoom * (this.dispH - 100 - 150);
      }
    },
    left() {
      return (-(this.zoom - 1) / 2.0) * this.vwidth;
    },
    top() {
      return (-(this.zoom - 1) / 2.0) * this.vheight;
    }
  }
};
</script>
<style scoped>
.video {
  width: 100%;
  height: 100%;
}

.video-mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tocenter {
  font-size: 20px;
  font-style: normal;
}

.but-switch {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 2px 0px;
  background: rgba(45, 48, 57, 0.5);
}

.speed-switch {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 2px 0px;
  background: rgba(45, 48, 57, 0.5);
}

/deep/ .el-slider__marks-text {
  font-size: 20px;
  margin-top: -45px;
}

/deep/ .el-slider__stop {
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: red transparent transparent transparent;
  bottom: -1px;
  border-radius: 0;
  background-color: inherit;
}

/deep/ .el-slider__button-wrapper {
  z-index: 1;
}

/deep/ .el-radio-group {
  padding-left: 10px;
}

/deep/ .el-radio__label {
  font-size: 20px;
  vertical-align: middle;
  margin-right: 10px;
}

/deep/ .el-radio__inner {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/PupilConeaVideo.vue